import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from '@/app/routes';

/**
 * One sidebar entry, five routed tabs. Two DIFFERENT effect systems meet
 * here on purpose — keep them visually separated by the divider:
 *  - Packs   = the legacy template-engine curation channel (MySQL-backed
 *              effect_pack rows, served via /api/effect-packs/v1.json)
 *  - Create / Drafts / Review / Catalog = the .tfx render-engine pipeline
 *              (Create = AI PROMPT jobs on the Mac mini worker; S3 catalog
 *              behind the mobile asset CDN)
 * All tabs share the CONTENT role trio; per-tab gating stays on the routes.
 */
const TABS = [
  { to: ROUTES.tfxCreate, label: 'Create' },
  { to: ROUTES.tfxDrafts, label: 'Drafts' },
  { to: ROUTES.tfxReview, label: 'Review' },
  { to: ROUTES.tfxPublished, label: 'Catalog' },
  { to: ROUTES.effectPacks, label: 'Packs (legacy)', divider: true },
] as const;

export function EffectsHubLayout() {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border px-6 pt-5">
        <h1 className="text-xl font-semibold">Effects</h1>
        <nav className="mt-3 flex items-center gap-1" aria-label="Effect sections">
          {TABS.map((tab) => (
            <div key={tab.to} className="flex items-center">
              {'divider' in tab && tab.divider ? (
                <span className="mx-2 h-4 w-px bg-border" aria-hidden />
              ) : null}
              <NavLink
                to={tab.to}
                className={({ isActive }) =>
                  `-mb-px border-b-2 px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? 'border-primary font-medium text-foreground'
                      : 'border-transparent text-muted-foreground hover:text-foreground'
                  }`
                }
              >
                {tab.label}
              </NavLink>
            </div>
          ))}
        </nav>
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
